(function () {
  'use strict';

  var initialized = new WeakSet();

  function initToolbar(root) {
    if (initialized.has(root)) return;
    initialized.add(root);

    var filterToggle = root.querySelector('[data-filter-toggle]');
    var filterPanel = root.querySelector('[data-filter-panel]');
    var filterArrow = root.querySelector('[data-filter-arrow]');
    var sortToggle = root.querySelector('[data-sort-toggle]');
    var sortMenu = root.querySelector('[data-sort-menu]');
    var sortArrow = root.querySelector('[data-sort-arrow]');
    var sortLabel = root.querySelector('[data-sort-label]');
    var sortInput = root.querySelector('[data-sort-input]');
    var sortOptions = root.querySelectorAll('[data-sort-option]');
    var form = root.querySelector('[data-collection-form]');
    var filterInputs = root.querySelectorAll('[data-filter-panel] input');

    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function () {
        var isOpen = filterPanel.style.display === 'block';
        filterPanel.style.display = isOpen ? 'none' : 'block';
        filterToggle.setAttribute('aria-expanded', String(!isOpen));
        if (filterArrow) filterArrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    }

    function closeSort() {
      if (!sortMenu) return;
      sortMenu.style.display = 'none';
      if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
      if (sortArrow) sortArrow.style.transform = 'rotate(0deg)';
    }

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = sortMenu.style.display === 'block';
        sortMenu.style.display = isOpen ? 'none' : 'block';
        sortToggle.setAttribute('aria-expanded', String(!isOpen));
        if (sortArrow) sortArrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
      });

      document.addEventListener('click', function (event) {
        if (sortMenu.style.display === 'block' && !sortMenu.contains(event.target) && !sortToggle.contains(event.target)) {
          closeSort();
        }
      });
    }

    sortOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        if (sortInput) sortInput.value = option.dataset.sortValue;
        if (sortLabel) sortLabel.textContent = option.textContent.trim();
        closeSort();
        if (form) form.submit();
      });
    });

    filterInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (form) form.submit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-collection-toolbar]').forEach(initToolbar);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-collection-toolbar]') : null;
    if (root) initToolbar(root);
  });
})();
